import lodash from 'lodash';
import security from 'stores/security';

/**
 * @description 获取动态的cacheKey, 用于在缓存中区分不同用户的数据
 * @param prefix 缓存前缀, 不同的业务模块用不同的前缀
 * @returns 返回一个拼接了用户uuid的cacheKey
 */
export function getDynamicCacheKey(prefix: string) {
    return `${prefix}${security.userInfo?.uuid || ''}`;
}

/**
 * @description 判断用户信息是否是空值, 空值一般是null, undefined 或者空字符串
 * 0不能认为是空值, 因为某些字段的值是可以为0的
 */
export function isEmptyValue(value): boolean {
    return lodash.isNil(value) || value === '';
}

/**
 * 处理浮点数输入，确保输入的字符串符合有效的浮点数格式
 *
 * 该函数通过以下步骤处理输入字符串：
 * 1. 对输入字符串逐字符检查，只保留有效的数字字符、小数点和负号（如果允许）
 * 2. 确保小数点只出现一次，且不在字符串开头
 * 3. 确保负号只出现在字符串开头（如果允许负数）
 * 4. 移除开头多余的0（如"00123"会变成"123"，但"0.123"保持不变）
 *
 * @param input 需要处理的输入字符串
 * @param allowNegative 是否允许负数，默认为false
 * @returns 处理后的有效浮点数字符串
 *
 * 使用场景：
 * - 用户输入数字时进行实时校验和格式化
 * - 确保表单中的浮点数输入格式正确
 */
export function getValidFloatNumberInput(input: string, allowNegative: boolean = false): string {
    const charArray: string[] = [];
    let hasDot = false;

    for (let i = 0; i < input.length; i++) {
        const char = input.charAt(i);

        if (char === '-' && allowNegative && i === 0) {
            charArray.push(char);

            continue;
        }

        if (char === '.') {
            if (i === 0 || hasDot) {
                break;
            }

            hasDot = true;

            charArray.push(char);

            continue;
        }

        if (!/\d/.test(char)) {
            break;
        }

        charArray.push(char);
    }

    while (charArray.length > 1 && charArray[0] === '0' && charArray[1] !== '.') {
        charArray.shift();
    }

    return charArray.join('');
}
